import React, { useState, useEffect, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

import AppDispatcher from '../../../dispatchers/AppDispatcher'
import { NumberInput } from '../Inputs/Inputs'
import styles from '../../../../css/settings.module.css'

const SettlingTime = ({ device }) => {
  const defaultSettings = {
    settings: {
      settlingTime: 5,
      update: 0,
    },
  }

  const {
    application_settings: applicationSettings = defaultSettings,
    application_settings_new: applicationSettingsNew = defaultSettings,
  } = device || {}

  const {
    settings: {
      settlingTime = 5,
      update = 0,
    } = {},
  } = applicationSettings

  const {
    settings: {
      settlingTime: newSettlingTime, update: newUpdate,
    } = {},
  } = applicationSettingsNew

  const [settlingTimeState, setSettlingTimeState] = useState(newSettlingTime || settlingTime)
  const [updateState, setUpdateState] = useState(Number(newUpdate == 0 || newUpdate == 1 ? newUpdate : update))

  const appDispatch = useCallback(() => {
    const { address } = device

    AppDispatcher.dispatch({
      action: 'change-setting',
      setting: {
        address,
        status: 'new',
        settings: {
          settlingTime: settlingTimeState,
          update: Number(updateState),
        },
      },
    })
  }, [settlingTimeState, updateState, device])

  useEffect(() => {
    appDispatch()
  }, [settlingTimeState, updateState])

  const childChange = useCallback((event) => {
    const { target: { name, value } } = event
    let newValue = value

    if (name === 'settlingTime' && value > 60) newValue = 60
    if (name === 'settlingTime' && value < 0) newValue = 0
    if (name === 'update' && (value < 0 || value > 1)) newValue = 0

    if (name === 'settlingTime') {
      setSettlingTimeState(newValue)
    } else if (name === 'update') {
      setUpdateState(newValue)
    }
  }, [appDispatch])

  return (
    <div>
      <div className={styles.inputArea}>
        <section>
          <h5>
            <FormattedMessage
              id='setting.settlingTime.label'
              defaultMessage='Settling Time'
              description='settling time label'
            />
          </h5>
          <div className={styles.otherNumber}>
            <NumberInput
              value={settlingTimeState}
              childChange={childChange}
              field='settlingTime'
              max={60}
              min={0}
              steps={1}
              style={styles.otherNumberInput}
            />
          </div>
          <div>
            <FormattedMessage
              id='setting.minutes'
              defaultMessage='minutes'
              description='minutes label'
            />
          </div>
        </section>
      </div>
    </div>
  )
}

SettlingTime.propTypes = {
  device: PropTypes.object.isRequired,
}

export default SettlingTime
